import type { EffectParams } from '@swf/core/store';
import type { CasinoGameInstance } from '@swf/core/types/CasinoGame';
import { JoinReason } from '@swf/core/types/CasinoGame';
import { getWindow } from '@swf/core/utils/casino';

const reconnect = async (
  payload: { instance: CasinoGameInstance },
  { rootState, dispatch }: EffectParams
) => {
  const { instance } = payload;
  const windowRef = getWindow({ table: instance, rootState });
  dispatch.casino.open({ instance, joinReason: JoinReason.Play, windowRef });
};

export default reconnect;
